
import { Component, Mixins } from "vue-property-decorator";
import { IDateInputBehavior } from "../../../../../../documaker/domain/format/objects";
import { IDateInputBehaviorPropertyEditable, instanceOfIDateInputBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class DateInputBehaviorPropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: IDateInputBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IDateInputBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isDateInputBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIDateInputBehaviorPropertyEditable(s) && s.dateInputBehavior().isEditable(), false);
  }

  get dateInputBehavior(): IDateInputBehavior {
    return this.readPropertyOrDefault(s => s.dateInputBehavior().getValue(), { isFuzzyInputtable: true });
  }

  set dateInputBehavior(value: IDateInputBehavior) {
    this.writePropertyWhenValid(s => s.dateInputBehavior().setValue(value));
  }
}
